var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04894 1.42705C7.3483 0.505739 8.6517 0.50574 8.95106 1.42705L10.0206 4.71885C10.1545 5.13087 10.5385 5.40983 10.9717 5.40983H14.4329C15.4016 5.40983 15.8044 6.64945 15.0207 7.21885L12.2205 9.25329C11.87 9.50793 11.7234 9.9593 11.8572 10.3713L12.9268 13.6631C13.2261 14.5844 12.1717 15.3506 11.388 14.7812L8.58778 12.7467C8.2373 12.4921 7.7627 12.4921 7.41221 12.7467L4.61204 14.7812C3.82833 15.3506 2.77385 14.5844 3.0732 13.6631L4.14277 10.3713C4.27665 9.9593 4.12999 9.50793 3.7795 9.25329L0.979333 7.21885C0.195619 6.64945 0.598395 5.40983 1.56712 5.40983H5.02832C5.46154 5.40983 5.8455 5.13087 5.97937 4.71885L7.04894 1.42705Z",
    fill: "#FFC600"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6b648394ada4962e470b91092da26e02.svg";
export { ForwardRef as ReactComponent };